module.exports = __webpack_public_path__ + "img/tip.307c8b11.png";